/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{mix as o}from"../mix.js";import{progress as r}from"../progress.js";function t(t,s){const m=t[t.length-1];for(let n=1;n<=s;n++){const p=r(0,s,n);t.push(o(m,1,p))}}export{t as fillOffset};
//# sourceMappingURL=fill.js.map
